export const PARAMETRO_SISTEMA = 'PARAMAZPITIA'
export const USER_LOCAL_STORAGE = 'USER'